import { render, staticRenderFns } from "./NewPageSearchReservation.vue?vue&type=template&id=1b413f1b"
import script from "./NewPageSearchReservation.vue?vue&type=script&lang=js"
export * from "./NewPageSearchReservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports